import React from 'react';
import { Button as AntdButton, ButtonProps } from 'antd';
import cx from 'classnames';
import { useTheme } from '@ui/hooks';
import { AntdConfigProvider } from '..';
import './styles.css';

export const Button = (props: ButtonProps) => {
  const { className, ...rest } = props;
  const { baseButton } = useTheme();
  return (
    <AntdConfigProvider theme={{ components: { Button: baseButton } }}>
      <AntdButton className={cx('styled-button', className)} shape="round" {...rest} />
    </AntdConfigProvider>
  );
};
